module.exports = __webpack_public_path__ + "static/media/footer.4a2f669b.png";